import { Trans, useTranslation } from 'react-i18next'

import { Text } from '@reveni-io/reveni-ui'

import GiftCardBalanceSkeleton from './GiftCardBalanceSkeleton/GiftCardBalanceSkeleton'

const GiftCardBalance = ({ giftCard, loading }) => {
  const { i18n } = useTranslation()

  if (loading) return <GiftCardBalanceSkeleton />
  if (!giftCard) return null

  return (
    <Text type="bodyMRegular">
      <Trans
        i18nKey="El saldo restante de esta tarjeta regalo es de <bold>{{remaining}}</bold> (Saldo inicial: {{opening}})"
        values={{
          remaining: new Intl.NumberFormat(i18n.language, { style: 'currency', currency: giftCard.currency }).format(
            giftCard.remaining_amount
          ),
          opening: new Intl.NumberFormat(i18n.language, { style: 'currency', currency: giftCard.currency }).format(
            giftCard.amount
          ),
        }}
        components={{ bold: <strong /> }}
      />
    </Text>
  )
}

export default GiftCardBalance
